/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import DriveUtil from '../drive/drive-util';

import isNil from 'lodash/isNil';

/**
 * Detektor volného místa na disku
 */
class Detector {
  /**
   * Vytvoří instanci.
   * @param {DriveManager} driveManager
   * @returns {Detector} Nová instance.
   */
  constructor(driveManager) {
    this.driveManager = driveManager;
  }

  /**
   * Detekuje, jestli je na disku dostatek volného místa.
   * @param {Byte} size Velikost požadovaného místa.
   * @returns {Promise.<boolean>} Příznak, jestli je dostatek volného místa.
   */
  detect(size) {
    return new Promise((resolve) => {
      if (!Number.isFinite(size)) {
        throw new TypeError(`Invalid size ${size}.`);
      }
      return resolve(
        this.driveManager.getInfo().then((driveInfo) => {
          // Výběr hlavního disku.
          const driveUnit = DriveUtil.find(driveInfo.driveUnitArray);
          if (isNil(driveUnit)) {
            throw new Error('No drive unit found.');
          }
          // Porovnání volného místa s požadovaným.
          return driveUnit.free >= size;
        })
      );
    });
  }
}

export default Detector;
